import { Chip, CircularProgress, Tooltip } from '@mui/material';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import CloudOffIcon from '@mui/icons-material/CloudOff';

type IntegrationStatusBadgeProps = {
  status: 'success' | 'error' | 'loading';
  errorMessage?: string;
};

export const IntegrationStatusBadge = ({
  status,
  errorMessage,
}: IntegrationStatusBadgeProps) => {
  switch (status) {
    case 'loading':
      return <CircularProgress size={16} />;
    case 'success':
      return (
        <Chip
          size='small'
          icon={<RssFeedIcon />}
          label='Bağlı'
          color='success'
        />
      );
    default: {
      const chip = (
        <Chip size='small' icon={<CloudOffIcon />} label='Hata' color='error' />
      );
      return errorMessage ? (
        <Tooltip title={errorMessage}>{chip}</Tooltip>
      ) : (
        chip
      );
    }
  }
};
